/**
 * TODO: Replace this local ModalHeader with @fluentsms/agentnet-web-components once
 * the MUI and React version upgrade is complete. AgentNetPortal currently uses Material-UI v4
 * and React 17, while lib-agentnet targets MUI v7 and React 19, so the shared component
 * cannot be used directly today. Vahe is working on the upgrade, but it will take time;
 * once that work lands, switch back to the lib-agentnet ModalHeader.
 */
import { Box, IconButton, makeStyles, Theme, Typography } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { FC } from 'react';

export interface ModalHeaderProps {
  title: string;
  onClose: () => void;
  closeButtonDataTestId?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  title: {
    fontWeight: 600,
    fontSize: '1.25rem',
    lineHeight: 1.2,
  },
  closeButton: {
    padding: theme.spacing(0.5),
    marginRight: theme.spacing(-0.5),
  },
}));

export const ModalHeader: FC<ModalHeaderProps> = ({ title, onClose, closeButtonDataTestId }) => {
  const classes = useStyles();

  return (
    <Box className={classes.headerContainer}>
      <Typography variant="h6" className={classes.title}>
        {title}
      </Typography>
      <IconButton
        onClick={onClose}
        aria-label="Close modal"
        className={classes.closeButton}
        data-testid={closeButtonDataTestId}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
};
